import { Select } from "@mui/material";
import React from "react";
import { ValueObjectType } from "../../organisms/CascaderField/helpers";
import { OptionType } from "../../../services/helpers/types";
import CascaderOptionItem from "../CascaderOptionItem/CascaderOptionItem";

interface CascaderOptionsProps {
  currentValue: string[];
  selectOpen: boolean;
  options: OptionType[];
  currentValueObject: ValueObjectType;
  onSelectOpen: (isOpen: boolean) => void;
  onSubSelectOpen: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
    option: OptionType
  ) => void;
  onBaseOptionSelect: (option: OptionType) => void;
}

const CascaderOptions = (props: CascaderOptionsProps) => {
  const {
    currentValue,
    selectOpen,
    options,
    currentValueObject,
    onSelectOpen,
    onSubSelectOpen,
    onBaseOptionSelect,
  } = props;

  const handleOutsideClick = (e: React.FocusEvent<HTMLDivElement, Element>) => {
    if (e.relatedTarget === null) {
      onSelectOpen(false);
    }
  };
  return (
    <Select
      multiple
      value={currentValue}
      open={selectOpen}
      onOpen={() => onSelectOpen(true)}
      renderValue={() => `${currentValue}`}
      onFocusCapture={(e) => handleOutsideClick(e)}
      className="dui-cascader-menu"
    >
      {options.length > 0
        ? options.map((option) => (
            <CascaderOptionItem
              currentValueObject={currentValueObject}
              onBaseOptionSelect={onBaseOptionSelect}
              onSubSelectOpen={onSubSelectOpen}
              option={option}
              key={option.optionID}
            />
          ))
        : null}
    </Select>
  );
};

export default CascaderOptions;
